module.exports = __webpack_public_path__ + "media/excellusbcbs-member@md-2d296342db6bed4e2af4a00ab5db6172.jpg";